import React, { useMemo } from "react";
import { Form, Select } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "components/use-hooks";


const StaffSubcontractorSelect = ({
    eventSubcontractors = [],
    form,
    name = "subcontractor_id",
    selected = false,
    onChange = () => {},
}) => {
    const translations = useTranslation();
    const subcontractorLabel = translations[ "SEARCH.Input_Placeholder_Subcontractor" ] || "Search for subcontractor";
    const allSubcontractorsLabel = translations[ "STAFF_MANAGEMENT.Filter_AllSubcontractors" ] || "All subcontractors";
    const options = useMemo(() => {
        const subcontractorsByID = new Map();

        (Array.isArray(eventSubcontractors) ? eventSubcontractors : []).forEach((subcontractor) => {
            const id = String(subcontractor?.id ?? "").trim();

            if (id)
            {
                subcontractorsByID.set(id, {
                    value: id,
                    label: subcontractor.title || id,
                });
            }
        });

        return [
            { value: "all", label: allSubcontractorsLabel },
            ...subcontractorsByID.values(),
        ];
    }, [ allSubcontractorsLabel, eventSubcontractors ]);

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ subcontractorLabel }
                clearIcon={ <CloseOutlined /> }
                showArrow
                showSearch
                className={ `staff-filter-subcontractor${
                    selected ? " staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-filter-subcontractor-dropdown"
                filterOption={ (input, option) => (
                    option?.value === "all" ||
                    String(option?.label || "").toLowerCase().includes(input.trim().toLowerCase())
                ) }
                options={ options }
                placeholder={ subcontractorLabel }
                suffixIcon={ selected ? null : <SearchOutlined /> }
                onChange={ (value) => {
                    const nextValue = value === "all" ? undefined : value;

                    form.setFieldsValue({ [ name ]: nextValue });
                    onChange(nextValue);
                } } />
        </Form.Item>
    );
};

export default StaffSubcontractorSelect;
